import { useParams } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import { useGetParcelShop } from '@dhl/mdp-api'
import { Box, Grid } from '@dhl-ui/components'

import { links } from '~/AppRoutes'
import { useNavigateWithSearchString } from '~/common/hooks'
import { ServicePointDetails, UsersCard } from '~/modules/servicepoints/components'
import { BackButton } from '~/temp-ds-component/BackButton'

type Params = {
  id: string
}

export const ServicePointDetailsPage = () => {
  const { id } = useParams<Params>()
  const navigateWithSearchString = useNavigateWithSearchString(true)
  const { t } = useTranslation()

  const { data: servicePointDto, isLoading } = useGetParcelShop(id || '')

  if (isLoading || !servicePointDto || !id) {
    return null
  }

  const onBack = () => navigateWithSearchString(links.servicePointsLink())

  return (
    <>
      <Box margin={2}>
        <BackButton onClick={onBack}>{t('admin.servicePointsPage.servicePointDetails.backButtonTitle')}</BackButton>
      </Box>
      <Grid direction="row" container spacing={3}>
        <Grid size={{ sm: 5 }}>
          <Box mb={2}>
            <ServicePointDetails servicePoint={servicePointDto} />
          </Box>
        </Grid>
        <Grid size={{ sm: 7 }}>
          <Box mb={2}>
            <UsersCard organisationId={id} />
          </Box>
        </Grid>
      </Grid>
    </>
  )
}
